import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import shreefone from '../../shreefone.png'
import axios from 'axios';
import {
  FiShare2,
  FiArrowLeft,
  FiShoppingCart,
  FiTruck,
  FiPhoneCall
} from 'react-icons/fi';
import { v4 as uuidv4 } from 'uuid';
import districtData from '../../data/districtData';
import useEsewaPayment from "../../hooks/useEsewaPayment";
import styles from './Buynow.module.css';
import Spcart from '../../usercomponents/Spcart/Spcart';
import { usePurchase } from "../../hooks/usePurchase";
import config from '../../config/config';

const Buynow = () => {
  const { ids } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImages, setSelectedImages] = useState({});
  const [quantities, setQuantities] = useState({});
  const [sharedIds, setSharedIds] = useState({});
  const [showSpMycart, setShowSpMycart] = useState(false);
  const [activeProducts, setActiveProducts] = useState([]);
  const { initiatePayment, loading: paymentLoading } = useEsewaPayment();
  const [showImage, setShowImage] = useState(false);

const [localPaymentLoading, setLocalPaymentLoading] = useState(false);

  
  // Shipping related states
  const [shippingAddress, setShippingAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [shippingCost, setShippingCost] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
 const [userData, setUserData] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');


  // Weight utility functions
  const formatWeight = (weight) => {
    if (!weight) return '0 kg';
    const kg = weight.unit === 'g' ? weight.value / 1000 : weight.value;
    return kg % 1 === 0 ? `${kg}kg` : `${kg.toFixed(1)}kg`;
  };

  const getWeightInKg = (weight) => {
    if (!weight) return 0;
    return weight.unit === 'g' ? weight.value / 1000 : weight.value;
  };

  // Calculate totals
  const subtotal = products.reduce((total, product) => {
    const qty = quantities[product._id] || 1;
    const price = product?.pdprice?.npr || 0;
    return total + qty * price;
  }, 0);
  
  const totalPrice = subtotal + shippingCost;

// Add this function to calculate weight-based additional charges
const calculateWeightCharge = (products, quantities) => {
  const totalWeightKg = products.reduce((total, product) => {
    const qty = quantities[product._id] || 1;
    return total + qty * getWeightInKg(product?.weight);
  }, 0);

  // Calculate additional NPR 10 for every 0.5kg
  return Math.ceil(totalWeightKg / 0.5) * 10;
};

// Modify your existing calculateShippingCost function
const calculateShippingCost = useCallback((address, code) => {
  let cost = 150; // Default base cost

  if (!districtData || typeof districtData !== 'object') {
    const weightCharge = calculateWeightCharge(products, quantities);
    setShippingCost(cost + weightCharge);
    return;
  }

  const cleanCode = code ? code.toString().trim() : '';
  const cleanAddress = address ? address.toLowerCase().trim() : '';

  // Search for location-based cost
  for (const province of Object.values(districtData)) {
    if (!province) continue;
    
    for (const district of Object.values(province)) {
      if (!district?.local_level_units) continue;
      
      if (cleanCode) {
        const codeMatch = district.local_level_units.find(
          unit => unit.postal_code?.toString().trim() === cleanCode
        );
        if (codeMatch) {
          cost = codeMatch.shipping_cost;
          break;
        }
      }

      if (cleanAddress && cost === 150) {
        const addressMatch = district.local_level_units.find(
          unit => unit.name?.toLowerCase().trim() === cleanAddress
        );
        if (addressMatch) {
          cost = addressMatch.shipping_cost;
          break;
        }
      }
    }
  }

  // Add weight-based charge
  const weightCharge = calculateWeightCharge(products, quantities);
  setShippingCost(cost + weightCharge);
}, [products, quantities]);
 

  useEffect(() => {
    // Debug: Check if ANY district data loads
    const firstProvince = Object.values(districtData)[0];
    const firstDistrict = firstProvince ? Object.values(firstProvince)[0] : null;
    
  

    calculateShippingCost(shippingAddress, postalCode);
  }, [shippingAddress, postalCode, calculateShippingCost]);

  const handleAddressChange = (value) => {
    setShippingAddress(value);
    
    if (!value || value.length < 2) {
      setSuggestions([]);
      return;
    }
  
    const searchTerm = value.toLowerCase().trim();
    const matches = [];
  
    // Search through all locations
    Object.values(districtData).forEach(province => {
      Object.values(province).forEach(district => {
        if (district?.local_level_units) {
          district.local_level_units.forEach(unit => {
            if (unit.name.toLowerCase().includes(searchTerm)) {
              matches.push({
                name: unit.name,
                postal_code: unit.postal_code,
                shipping_cost: unit.shipping_cost,
                district: Object.keys(district).find(key => district[key] === district)
              });
            }
          });
        }
      });
    });
  
    // Sort by relevance (exact matches first)
    matches.sort((a, b) => {
      const aStartsWith = a.name.toLowerCase().startsWith(searchTerm);
      const bStartsWith = b.name.toLowerCase().startsWith(searchTerm);
      
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      return a.name.localeCompare(b.name);
    });
  
    setSuggestions(matches.slice(0, 5)); // Show top 5 matches
  };

  const handlePostalCodeChange = (code) => {
    const cleanCode = code.replace(/\D/g, '');
    setPostalCode(cleanCode);
  };

  useEffect(() => {
  const fetchUserData = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoadingUser(false);
      return;
    }

    try {
      const response = await axios.get(`${config.apiBaseUrl}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUserData(response.data);
      // Set the phone number if available
      if (response.data.contact) {
        setPhoneNumber(response.data.contact);
      }
    } catch (error) {
      console.error('Failed to fetch user data:', error);
    } finally {
      setLoadingUser(false);
    }
  };

  fetchUserData();
}, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const idArray = ids.split(',');
        const res = await axios.post(`${config.apiBaseUrl}/api/products/batch`, { ids: idArray });
        setProducts(res.data);
        setActiveProducts(res.data);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch products', err);
        setError(err.response?.data?.message || 'Products not found');
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [ids]);

  const handleShare = (product) => {
    if (navigator.share) {
      navigator.share({
        title: product.productName,
        text: `Check out this product: ${product.productName}`,
        url: window.location.href,
      })
      .then(() => setSharedIds(prev => ({ ...prev, [product._id]: true })))
      .catch((error) => console.log('Error sharing:', error));
    } else {
      const shareUrl = `${window.location.origin}/products/${product._id}`;
      navigator.clipboard.writeText(shareUrl)
        .then(() => setSharedIds(prev => ({ ...prev, [product._id]: true })))
        .catch(() => alert(`Share this link: ${shareUrl}`));
    }
  };

  const handleAddToCart = async (product) => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert('Login to Add items in Cart');
      navigate('/shreeohm/login');
      return;
    }

    try {
      const response = await axios.post(
        `${config.apiBaseUrl}/api/users/addtocart`,
        {
          productId: product._id,
          quantity: quantities[product._id] || 1
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message);
      
    } catch (error) {
      console.error('Error adding product to cart:', error.response?.data || error.message);
      alert('Error adding product to cart');
    }
  };

  const handleCancel = (productId) => {
    const updatedProducts = activeProducts.filter(p => p._id !== productId);
    setActiveProducts(updatedProducts);
    const updatedIds = updatedProducts.map(p => p._id).join(',');
    navigate(`/buynow/${updatedIds}`, { replace: true });
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}></div>
        <p>Loading product details...</p>
      </div>
    );
  }

  if (error || products.length === 0) {
    return (
      <div className={styles.errorContainer}>
        <h2>{error || 'Product(s) not found'}</h2>
        <button className={styles.backButton} onClick={() => navigate('/')}>
          <FiArrowLeft /> Continue Shopping
        </button>
      </div>
    );
  }
const handlePurchase = async () => {
  if (!shippingAddress || !postalCode || !phoneNumber) {
    alert("Please fill all shipping details");
    return;
  }

  const email = userData?.email || prompt("Please enter your email for guest checkout:");
  if (!email) return;

  try {
    const token = localStorage.getItem("token");

    const transactionId = uuidv4();

    const orderData = {
      products: products.map((product) => {
        const qty = quantities[product._id] || 1;
        const price = product?.pdprice?.npr || 0;
        return {
          productId: product._id,
          name: product.productName,
          price,
          quantity: qty,
          weight: qty * getWeightInKg(product?.weight),
        };
      }),
      shippingDetails: {
        address: shippingAddress,
        postalCode,
        phone: phoneNumber,
        email,
      },
      totalAmount: subtotal + shippingCost,
      shippingCost,
      transactionId,
    };

    // Save order on backend
    const response = await axios.post(
      `${config.apiBaseUrl}/api/purchased-products`,
      orderData,
      token ? { headers: { Authorization: `Bearer ${token}` } } : {}
    );

    console.log("Order saved:", response.data);

    // Call your existing initiatePayment hook with amount and transactionId
    await initiatePayment({ amount: totalPrice, transaction_uuid: transactionId });
  } catch (error) {
    console.error("Purchase error:", error.response?.data || error.message);
    alert(error.response?.data?.message || "Purchase failed. Please try again.");
  }
};

const handleOrder = async () => {
  if (!shippingAddress || !postalCode || !phoneNumber) {
    alert("Please fill all shipping details");
    return;
  }

  const email = userData?.email || prompt("Please enter your email for guest checkout:");
  if (!email) return;

  try {
    const token = localStorage.getItem("token");

    const orderData = {
  userId: userData?._id, // <-- include this
  products: products.map((product) => {
    const qty = quantities[product._id] || 1;
    const price = product?.pdprice?.npr || 0;
    return {
      productId: product._id,
      name: product.productName,
      price,
      quantity: qty,
      weight: qty * getWeightInKg(product?.weight),
    };
  }),
  shippingDetails: {
    address: shippingAddress,
    postalCode,
    phone: phoneNumber,
    email,
  },
  totalAmount: subtotal + shippingCost,
  shippingCost,
  orderType: "cashOnDelivery",
};


    const response = await axios.post(
      `${config.apiBaseUrl}/api/user-orders`,
      orderData,
      token ? { headers: { Authorization: `Bearer ${token}` } } : {}
    );

    console.log("Order saved:", response.data);
    alert("Your order has been placed successfully!");
    setTimeout(() => navigate('/my-orders'), 1000);
  } catch (error) {
    console.error("Order error:", error.response?.data || error.message);
    alert(error.response?.data?.message || "Order failed. Please try again.");
  }
};

const handleShowImg = () => {
  setShowImage(prev => !prev);
};


  return (
    <div className={styles.sproot}>
      <div className={styles.spleft}>
        <div className={styles.container}>
          <button
            className={styles.backButton}
            onClick={() => navigate(window.history.length <= 2 ? '/' : -1)}
          >
            <FiArrowLeft /> Back to Products
          </button>

          <div className={styles.bnow}><h2>Buy Now</h2></div>

          {activeProducts.map((product) => {
            const selectedImage = selectedImages[product._id] || 0;
            const quantity = quantities[product._id] || 1;

            return (
              <div key={product._id} className={styles.productContainer}>
                <div className={styles.cnclcrt}>
                  <button className={styles.cncl} onClick={() => handleCancel(product._id)}>Cancel</button>
                  <button className={styles.adcrt} onClick={() => handleAddToCart(product)}>Add to CART</button>
                </div>

                <div className={styles.imageGallery}>
                  <img
                    src={product.images?.[selectedImage]?.url || 'https://via.placeholder.com/150'}
                    alt={product.productName}
                    className={styles.mainImage}
                    onError={(e) => (e.target.src = 'https://via.placeholder.com/150')}
                  />
                  {product.images?.length > 1 && (
                    <div className={styles.thumbnailContainer}>
                      {product.images.map((img, idx) => (
                        <img
                          key={idx}
                          src={img.url}
                          alt={`${product.productName} thumbnail ${idx + 1}`}
                          className={`${styles.thumbnail} ${selectedImage === idx ? styles.thumbnailActive : ''}`}
                          onClick={() => setSelectedImages(prev => ({ ...prev, [product._id]: idx }))}
                          onError={(e) => (e.target.src = 'https://via.placeholder.com/150')}
                        />
                      ))}
                    </div>
                  )}
                </div>

                <div className={styles.productInfo}>
                  <h1 className={styles.title}>{product.productName}</h1>
                  <div className={styles.priceContainer}>
                    <span className={styles.price}>NPR {product.pdprice?.npr?.toLocaleString()}</span>
                    {product.pdprice?.usd && (
                      <span className={styles.secondaryPrice}>
                        (${product.pdprice.usd?.toLocaleString()})
                      </span>
                    )}
                  </div>

                 <div className={styles.detailsBenefitsWrapper}>
  <div className={styles.detailBlock}>
    <h3 className={styles.sectionTitle}>Product Details</h3>
    {product.productDetails?.split('|').map((line, idx) => {
      const trimmed = line.trim();

      // Remove wrapping { } and detect whether it's custom text (no bullet)
      const isNoBullet = trimmed.startsWith('{') && trimmed.endsWith('}');
      const content = isNoBullet
        ? trimmed.slice(1, -1)
        : trimmed;

      // Replace [word] with <strong>word</strong>
      const formattedContent = content.split(/(\[[^\]]+\])/g).map((part, i) => {
        if (part.startsWith('[') && part.endsWith(']')) {
          return <strong key={i}>{part.slice(1, -1)}</strong>;
        }
        return part;
      });

      return (
        <p key={idx} className={styles.description}>
          {!isNoBullet && '• '}
          {formattedContent}
        </p>
      );
    })}
  </div>

  {product.benefits && (
    <div className={styles.detailBBlock}>
      <h3 className={styles.sectionTitle}>Benefits</h3>
      {product.benefits?.split('|').map((line, idx) => {
        const trimmed = line.trim();

        const isNoBullet = trimmed.startsWith('{') && trimmed.endsWith('}');
        const content = isNoBullet
          ? trimmed.slice(1, -1)
          : trimmed;

        const formattedContent = content.split(/(\[[^\]]+\])/g).map((part, i) => {
          if (part.startsWith('[') && part.endsWith(']')) {
            return <strong key={i}>{part.slice(1, -1)}</strong>;
          }
          return part;
        });

        return (
          <p key={idx} className={styles.description}>
            {!isNoBullet && '• '}
            {formattedContent}
          </p>
        );
      })}
    </div>
  )}
</div>



                  {product.categories?.length > 0 && (
                    <div className={styles.tagsContainer}>
                      {product.categories.map((cat, idx) => (
                        <span key={idx} className={styles.tag}>{cat}</span>
                      ))}
                    </div>
                  )}

                  <div className={styles.quantityContainer}>
                    <label className={styles.quantityLabel}>Quantity:</label>
                    <div className={styles.quantitySelector}>
                      <button
                        className={styles.quantityButton}
                        onClick={() => setQuantities(prev => ({
                          ...prev,
                          [product._id]: Math.max(1, (prev[product._id] || 1) - 1),
                        }))}
                        disabled={quantity <= 1}
                      >-</button>
                      <span className={styles.quantityValue}>{quantity}</span>
                      <button
                        className={styles.quantityButton}
                        onClick={() => setQuantities(prev => ({
                          ...prev,
                          [product._id]: (prev[product._id] || 1) + 1,
                        }))}
                      >+</button>
                    </div>
                  </div>

                  <div className={styles.deliveryInfo}>
                    <div className={styles.deliveryItem}>
                      <FiTruck className={styles.deliveryIcon} />
                      <span>Big Order Big Offer</span>
                    </div>
                    <div className={styles.deliveryItem}>
                      <FiPhoneCall className={styles.deliveryIcon} />
                      <span>Call us: 9858060350</span>
                    </div>
                  </div>
                  <button
                    className={styles.shareButton}
                    onClick={() => handleShare(product)}
                  >
                    <FiShare2 /> {sharedIds[product._id] ? 'Shared!' : 'Share Product'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        {showSpMycart && (
          <div className={styles.SpMycart}>
            <div className={styles.contTitle}>
              <h2>My Cart</h2>
              <Spcart/>
            </div>
          </div>
        )}
      </div>

      <div className={styles.spright}>
       <div className={styles.PurchaseCard}>
        {showImage && (
  <div className={styles.overlayImage}>
    <button className={styles.closeButton} onClick={handleShowImg}>
      ✕
    </button>
    <img 
      src={shreefone}
      alt="QR CODE"
      className={styles.fullImage}
    />
  </div>
)}

  <div className={styles.PchaseTitle}>
    

    <h2>Purchase Card</h2>
  </div>

  <table className={styles.purchaseTable}>
    <thead>
      <tr>
        <th>S.N</th>
        <th>Product</th>
        <th>Quantity</th>
        <th>Weight (kg)</th>
        <th>Price</th>
      </tr>
    </thead>
    <tbody>
      {products.map((product, index) => {
        const qty = quantities[product._id] || 1;
        const price = product?.pdprice?.npr || 0;
        return (
          <tr key={product._id}>
            <td>{index + 1}</td>
            <td>{product.productName}</td>
            <td>{qty}</td>
            <td>{formatWeight({ value: qty * getWeightInKg(product?.weight), unit: 'kg' })}</td>
            <td>NPR {(qty * price).toLocaleString()}</td>
          </tr>
        );
      })}
    </tbody>
  </table>

  <div className={styles.weightSection}>
    <div className={styles.weightRow}>
      <span>Total Weight:</span>
      <span className={styles.weightAmount}>
        {formatWeight({
          value: products.reduce((total, product) => {
            const qty = quantities[product._id] || 1;
            return total + qty * getWeightInKg(product?.weight);
          }, 0),
          unit: 'kg'
        })}
      </span>
    </div>
    <div className={styles.weightRow}>
      <span>Weight Charge:</span>
      <span className={styles.weightAmount}>
        NPR {Math.ceil(products.reduce((total, product) => {
          const qty = quantities[product._id] || 1;
          return total + qty * getWeightInKg(product?.weight);
        }, 0) / 0.5) * 10}
      </span>
    </div>
  </div>

  <div className={styles.totalSection}>
    <div className={styles.totalHRow}>
      <span>Subtotal:</span>
      <span>NPR {subtotal.toLocaleString()}</span>
    </div>
    <div className={styles.totalHRow}>
      <span>Base Shipping:</span>
      <span>NPR {(shippingCost - calculateWeightCharge(products, quantities)).toLocaleString()}</span>
    </div>
    <div className={styles.totalHRow}>
      <span>Weight Charge:</span>
      <span>NPR {calculateWeightCharge(products, quantities).toLocaleString()}</span>
    </div>
    <div className={styles.totalRow}>
      <strong style={{ color: "orange" }}>Total Shipping:</strong>
      <strong style={{ color: "#333566" }}>NPR {shippingCost.toLocaleString()}</strong>
    </div>
    <div className={styles.totalRow}>
      <strong style={{ color: "orange" }}>Total:</strong>
      <strong style={{ color: "#333566" }}>NPR {(subtotal + shippingCost).toLocaleString()}</strong>
    </div>
  </div>

  <div className={styles.shippingInfo}>
    <div className={styles.shippingCostDisplay}>
      Shipping Cost: NPR {shippingCost}
    </div>
    
    <div className={styles.shippingField}>
      <label>Shipping Address (Municipality/Rural Municipality):</label>
      <div className={styles.searchContainer}>
        <input 
          type="text" 
          placeholder="Search your local level unit..." 
          className={styles.shippingInput}
          value={shippingAddress}
          onChange={(e) => handleAddressChange(e.target.value)}
        />
        {suggestions.length > 0 && (
          <div className={styles.suggestionsDropdown}>
            {suggestions.map((unit, index) => (
              <div 
                key={`${unit.postal_code}-${index}`}
                className={styles.suggestionItem}
                onClick={() => {
                  setShippingAddress(unit.name);
                  setPostalCode(unit.postal_code);
                  setSuggestions([]);
                }}
              >
                <div className={styles.suggestionMainText}>{unit.name}</div>
                <div className={styles.suggestionSubText}>
                  {unit.postal_code} • NPR {unit.shipping_cost}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    
    <div className={styles.shippingField}>
      <label>Postal Code:</label>
      <input 
        type="text" 
        placeholder="Enter postal code" 
        className={styles.shippingInput}
        value={postalCode}
        onChange={(e) => handlePostalCodeChange(e.target.value)}
        maxLength="5"
      />
    </div>
    
    <div className={styles.shippingField}>
      <label>Phone No.:</label>
      <input 
        type="tel" 
        placeholder="Enter phone number" 
        className={styles.shippingInput} 
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        disabled={loadingUser}
      />
      {loadingUser && (
    <span className={styles.loadingText}>Loading user data...</span>
  )}
    </div>
  </div>
  <div className={styles.actionButtons}>
    <button
      className={`${styles.button} ${styles.buttonPrimary}`}
      disabled={paymentLoading}
      onClick={handlePurchase} // Call function to pass product details in Paymentsuccess.jsx
    >
      {paymentLoading ? 'Processing...' : 'Buy Now'}
    </button>
<div className={styles.OrderandPay}>
     <button
  className={styles.OrderNow}
  onClick={handleOrder}
>
  Order Now
</button>
<button
  className={styles.Pay}
  onClick={handleShowImg}
>
{showImage ? 'Hide QR' : 'QR Pay'}
</button>

</div>

    <button
      className={`${styles.button} ${styles.buttonSecondary}`}
      onClick={() => setShowSpMycart(true)}
    >
      <FiShoppingCart /> Add From Cart
    </button>    
  </div>
</div>
      </div>
    </div>
  );
};
export default Buynow;
